import { combineReducers } from 'redux';
import { jetpayPaymentProcessingSlice } from './jetpay/redux/slice';

export const paymentProcessingReducer = combineReducers({
  jetpay: jetpayPaymentProcessingSlice.reducer,
});
